import {API_ROOT_URL} from 'envs/_current/config'
import {photoSchema} from './schema/photoSchema'
import {createListTransform} from './utils/createListTransform'

// Route::get('photos/user/{id}/gets', 'PhotoController@getPhotosByUser');
export const photo_getPhotosByUser_Api = {
  backend: `Route::get('photos/user/{id}/gets', 'PhotoController@getPhotosByUser');`,
  root: API_ROOT_URL,
  path: '/photos/user/:id/gets',
  method: 'GET',
  schema: photoSchema,
  transform: createListTransform(photoSchema),
}
